import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";
import RichTextEditor from "@/components/RichTextEditor";

export function CustomerNotesTab({ notes, setNotes, onSave, saving }) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Notizen</CardTitle>
          <CardDescription>Allgemeine Informationen zum Kunden</CardDescription>
        </div>
        <Button size="sm" onClick={onSave} disabled={saving} data-testid="save-notes-btn">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
          Speichern
        </Button>
      </CardHeader>
      <CardContent>
        <RichTextEditor value={notes} onChange={setNotes} placeholder="Notizen eingeben..." />
      </CardContent>
    </Card>
  );
}
